import { api } from '@/lib/api'
import type { Alert, AlertListFilters, AlertListResponse } from '@/types/alert'

export async function listAlerts(filters: AlertListFilters = {}): Promise<AlertListResponse> {
  const { data } = await api.get<AlertListResponse>('/alerts/', {
    params: filters,
  })
  return data
}

export async function markAlertRead(alertId: number): Promise<Alert> {
  const { data } = await api.patch<Alert>(`/alerts/${alertId}/read`)
  return data
}

export async function acceptAlert(alertId: number): Promise<Alert> {
  const { data } = await api.patch<Alert>(`/alerts/${alertId}/accept`)
  return data
}
